import axios from "axios";

export interface PresignedUrlRequestItem {
  mimeType: string;
  nomeOriginal: string;
}

export interface PresignedUrlResponseItem {
  originalName?: string;
  uploadUrl?: string;
  url?: string;
  putUrl?: string;
  presignedUrl?: string;
  fileKey?: string;
  file_key?: string;
  key?: string;
}

export interface FotoEntregaPayload {
  caminho_foto: string;
  ferramenta?: string;
}

const buildConfig = (token: string) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

export const generatePresignedUrlsEntrega = async (
  token: string,
  payload: PresignedUrlRequestItem[]
): Promise<PresignedUrlResponseItem[]> => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/generate-presigned-urls`;
  const response = await axios.post<PresignedUrlResponseItem[]>(
    url,
    payload,
    buildConfig(token)
  );

  return response.data;
};

export const uploadToPresignedUrl = async (
  uploadUrl: string,
  fileBlob: Blob,
  mimeType: string
): Promise<void> => {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": mimeType,
    },
    body: fileBlob,
  });

  if (!response.ok) {
    throw new Error("Falha ao enviar imagem para o S3");
  }
};

export const salvarFotosEntrega = async (
  token: string,
  veiculoId: number,
  fotos: FotoEntregaPayload[]
): Promise<void> => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${veiculoId}/fotos`;
  await axios.post(url, { fotos }, buildConfig(token));
};
